'use client';

import { createContext, PropsWithChildren, useContext } from 'react';
import { PlanProduct } from '../../../../../types';
import { usePlanOnetimeAction } from '../../hooks';
export interface TossPaymentsWidgetProviderProps {
  price: number;
  selectedPlanInfo: PlanProduct;
  spaceHashId: string;
  isUpdate: boolean;
  spacePlanHashId: string;
  onetimeStartDate: Date;
  /** 전역 NiceModal 에서 렌더되어 페이지 컨텍스트를 읽을 수 없으므로 호출부가 넘긴다. */
  spaceId?: number;
}
export const TossPaymentsWidgetProvider = (props: PropsWithChildren<TossPaymentsWidgetProviderProps>) => {
  const {
    selectedPlanInfo,
    spaceHashId,
    isUpdate,
    spacePlanHashId,
    onetimeStartDate,
    price,
    spaceId
  } = props;
  const {
    isWidgetReady,
    handleClickOnetimePayment
  } = usePlanOnetimeAction({
    price,
    spaceHashId,
    spaceId,
    spacePlanTemplateId: selectedPlanInfo.id,
    onetimeStartDate,
    spacePlanHashId: isUpdate ? spacePlanHashId : undefined
  });
  return <TossPaymentsWidgetContext.Provider value={{
    isWidgetReady,
    handleClickOnetimePayment
  }} data-sentry-element="unknown" data-sentry-component="TossPaymentsWidgetProvider" data-sentry-source-file="TossPaymentsWidgetProvider.tsx">
      {props.children}
    </TossPaymentsWidgetContext.Provider>;
};
export const useTossPaymentsWidget = () => {
  const context = useContext(TossPaymentsWidgetContext);
  if (!context) {
    throw new Error('useTossPaymentsWidget must be used within a TossPaymentsWidgetProvider');
  }
  return context;
};
const TossPaymentsWidgetContext = createContext<TossPaymentsWidgetContextType | null>(null);
interface TossPaymentsWidgetContextType {
  isWidgetReady: boolean;
  handleClickOnetimePayment: () => void;
}